/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/MergeCard" />
import * as React from "react";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { Components } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { getPropertyValue } from "../Utils/ActivityFeedUtils";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";

export const MergeCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    let message;
    if (localeIgnoreCaseComparer(getPropertyValue(props.thread, "CodeReviewMergeStatus"), "Succeeded") == 0) {
        message = Resources.ActivityFeedMergeSucceeded;
    } else {
        message = Resources.ActivityFeedMergeFailed;
    }

    return (
        <Card className="flex-row flex-grow" contentProps={{ contentPadding: false }}>
            <ActivityCardSubtle createDate={props.thread.publishedDate}>{message}</ActivityCardSubtle>
        </Card>
    );
};

Components.add("ms.vss-code-web.merge-activity-card", MergeCard);
